import React from 'react';
import PropTypes from 'prop-types';
import {
  Form, InputNumber, Select, Alert,
} from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import './CapacitySubscriptionForm.less';

const CapacitySubscriptionForm = ({
  selectedYear,
  availableYears,
  onYearChange,
  period,
  subscribedCapacity,
  estimatedCostText,
  onCapacityChange,
  hasValidationError,
  isEditWindowOpen,
  children,
}) => {
  const { t } = useTranslation();
  const formattedStart = moment(period.startDate).format('D.M.YYYY');
  const formattedEnd = moment(period.endDate).format('D.M.YYYY');

  return (
    <Form className="capacitysubscriptionform" layout="vertical">
      <Form.Item label={t('capacitySubscription.form.label.year')}>
        <Select
          value={selectedYear}
          onChange={onYearChange}
          className="capacitysubscriptionform__year-select"
        >
          {availableYears.map(year => (
            <Select.Option key={year} value={year}>{year}</Select.Option>
          ))}
        </Select>
      </Form.Item>
      { !isEditWindowOpen && (
        <Alert
          type="warning"
          showIcon
          message={t('capacitySubscription.form.info.editWindowClosed')}
          className="capacitysubscriptionform__alert"
        />
      ) }
      <Form.Item label={t('capacitySubscription.form.label.period')}>
        <span className="capacitysubscriptionform__value">
          {`${formattedStart} — ${formattedEnd}`}
        </span>
      </Form.Item>
      <Form.Item
        label={t('capacitySubscription.form.label.capacity')}
        validateStatus={hasValidationError ? 'error' : ''}
        help={hasValidationError ? t('capacitySubscription.form.validation.capacityPositive') : null}
      >
        <InputNumber
          className="capacitysubscriptionform__capacity-input"
          min={0}
          precision={3}
          value={subscribedCapacity}
          onChange={onCapacityChange}
          decimalSeparator=","
        />
      </Form.Item>
      {estimatedCostText !== null && (
      <Form.Item label={t('capacitySubscription.form.label.estimatedCost')}>
        <span className="capacitysubscriptionform__value">{estimatedCostText}</span>
      </Form.Item>
      )}
      {children}
    </Form>
  );
};

CapacitySubscriptionForm.propTypes = {
  selectedYear: PropTypes.number.isRequired,
  availableYears: PropTypes.arrayOf(PropTypes.number).isRequired,
  onYearChange: PropTypes.func.isRequired,
  isEditWindowOpen: PropTypes.bool.isRequired,
  period: PropTypes.shape({
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
  }).isRequired,
  subscribedCapacity: PropTypes.number,
  estimatedCostText: PropTypes.string,
  onCapacityChange: PropTypes.func.isRequired,
  hasValidationError: PropTypes.bool,
  children: PropTypes.node,
};

CapacitySubscriptionForm.defaultProps = {
  subscribedCapacity: null,
  estimatedCostText: null,
  hasValidationError: false,
  children: null,
};

CapacitySubscriptionForm.displayName = 'CapacitySubscriptionForm';

export default CapacitySubscriptionForm;
